import angular from 'angular';
import sidebarUrl from './../sidebar/sidebar.html';

/* @ngInject */
export default function HomeComponent($scope, $location, $uibModal, $translate, CacheService, IconFormatterService, NavigationService, NotifyingService,
                                      PromoSpaceApiService, SleuthService, DefinitionModelService, NumberFormatterService, PartCountFormatterService,
                                      ContainerInfoApiService, APP_ERROR_CODES) {
    $scope.isProductsOpened = true;
    $scope.isParametersOpened = false;
    $scope.sideBarUrl = sidebarUrl;

    PromoSpaceApiService.getPromosBySize('TALL', function (promos) {
        $scope.promoSpace = promos[Math.floor(Math.random() * promos.length)];
    });

    $scope.responsiveSlickSettings = [
        {
            breakpoint: 1024,
            settings: {
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: true
            }
        },
        {
            breakpoint: 992,
            settings: {
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: true
            }
        },
        {
            breakpoint: 768,
            settings: {
                infinite: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: true
            }
        }
    ];


    // Clear show parameters in case user clicked browser back button
    $scope.clearShowParameters = function () {
        angular.forEach($scope.definitions, function (definition) {
            definition.showParameters = false;
        });
    };

    $scope.init = function () {
        var progressIndicator = document.getElementById('progressSpinner');
        angular.element(progressIndicator).removeClass('hidden');

        // Clear out current definition because the home page doesn't need it.
        CacheService.storeDefinition(undefined);
        CacheService.getParentDefinition().length = 0;
        NavigationService.closeMenu();

        // Clear out the Sleuth
        $scope.removeSleuthData();
        if (!$location.search().error && $location.search().error !== APP_ERROR_CODES.NO_RESULTS) {
            $scope.clearSearchBar();
        }

        // If the definitions are already in the cache, grab them out.
        if (CacheService.getAllDefinitions().length > 0) {
            $scope.definitions = CacheService.getAllDefinitions();
            $scope.clearShowParameters();
        } else {
            // If not, make costly request to grab them.
            DefinitionModelService.getModelInit();
            $scope.definitions = CacheService.getAllDefinitions();
        }

        // Don't really have to worry about this, because of how CacheService sets it up, but better safe.
        if ($scope.definitions.length !== undefined) {
            for (var i = 0; i < $scope.definitions.length; i++) {
                for (var j = 0; j < $scope.definitions[i].childDefinitions.length; j++) {
                    PartCountFormatterService.formatPartCount($scope.definitions[i].childDefinitions[j]);
                }
            }
        }

        if (!angular.element(progressIndicator).hasClass('hidden')) {
            angular.element(progressIndicator).addClass('hidden');
        }
    };

    $scope.init();

    NotifyingService.subscribeToModelServiceInit($scope, $scope.init);

    $scope.chooseRangeIcon = function (rangeName) {
        return IconFormatterService.chooseParameterIcon(rangeName);
    };

    $scope.traverse = function (parent, child) {
        // This method actually uses array.push()

        var updatedDef = NavigationService.findNextDefinition(child, parent);
        child = updatedDef.current;
        parent = updatedDef.parent;
        CacheService.storeParentDefinition(parent);
        // Store definition regularly.
        CacheService.storeDefinition(child);
        var params = {id: child.id};
        if ($location.search().search) {
            params.search = $location.search().search;
        }
        if (child.childDefinitions.length !== undefined && child.childDefinitions.length > 0) {
            $location.path('/browsing').search(params);
        } else {
            $location.path('/browsing/technology').search(params);
        }
    };

    $scope.removeSleuthData = function () {
        SleuthService.removeSleuthData();
    };

    $scope.clearSearchBar = function () {
        CacheService.storeOriginalQueryInput(undefined);
    };

    $scope.displayDefinitionName = function (definition) {
        if (CacheService.getConfigurationInfo() !== undefined) {
            return ContainerInfoApiService.getDisplayName(definition, CacheService.getConfigurationInfo().language);
        } else {
            return ContainerInfoApiService.getDisplayName(definition, 'ENGLISH');
        }
    };

    $scope.displayRangeName = function (range) {
        if (CacheService.getConfigurationInfo() !== undefined) {
            return ContainerInfoApiService.getDisplayName(range, CacheService.getConfigurationInfo().language);
        } else {        // Default to English
            return ContainerInfoApiService.getDisplayName(range, 'ENGLISH');
        }
    };

    $scope.dismissModal = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.getPartCountLabelByDefinition = function (definition) {
        return PartCountFormatterService.getLabelByDefinition(definition);
    }
}
